export default function validate(state, schema) {
  const validation = {}
  const fields = Object.keys(state)

  for (const field of fields) {
    const rules = schema[field]
    const value = state[field]

    for (const rule of rules) {
      if (rule.method(value) !== rule.validWhen) {
        validation[field] = rule.message
        break
      }
    }
  }

  return validation
}
